module.exports = __webpack_public_path__ + "static/media/ic-close.3a367ed1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/ic-close.svg
// module id = 105
// module chunks = 0